<template>
    <div>
      <v-row id="facility__social__links">
        <v-col cols="12">
          <h2 class="mt-4">Facility Social Media Links</h2>
        </v-col>
        <v-col
          cols="6"
          sm="5"
          lg="4"
          xl="3"
          class="prompt add-link rounded pr-7 ml-3 mt-8 mb-8"
          style="text-align: center; justify-content: center;"
          @click="addLink"
        >
          <v-icon x-large>add</v-icon>
          Click to add social media link
        </v-col>
      </v-row>

      <social-media-link
        v-for="(item, index) in items"
        :key="index"
        :index="index"
        :id="item.id"
        :icon="item.icon"
        :uri="item.uri"
        :iconList="iconList"
      />
    </div>
</template>

<script>
import SocialMediaLink from "@/components/SocialMediaLink";

export default {
  data() {
    return {
      modal: false
    };
  },

  computed: {
    currentFacility: {
      get() {
        return this.$store.state.facility.currentFacility;
      },
      set(newValue) {
        this.$store.commit("setCurrentFacilityData", newValue);
      }
    },

    items: {
      get() {
        return this.$store.state.facility.currentFacility.social_links;
      }
    },

    iconList: {
      get() {
        return this.$store.state.socialMediaIcons.icons;
      }
    }
  },

  components: {
    SocialMediaLink
  },

  mounted() {
    this.$store.dispatch("getIcons");
  },

  methods: {
    addLink() {
      this.$store.dispatch("addLink");
    }
  }
};
</script>

<style scoped>
.theme--dark .add-link {
    border: 1px solid #fff;
    cursor: pointer;
}

.theme--dark .add-link:hover {
    background: hsla(0,0%,100%,.08);
}

.theme--light .add-link {
    border: 1px solid #000;
    cursor: pointer;
}

.theme--light .add-link:hover {
    background: rgba(0,0,0,.12)
}
</style>
